module.exports = __webpack_public_path__ + "static/img/card_2_1.1447749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_2_1.png
// module id = +/k2
// module chunks = 0